// extracted by mini-css-extract-plugin
export default {"root":"SectionRight_root__zwNnL"};